import React from "react";
export const YOUTUBE_IFRAME_ID_PREFIX = "youtube-video-iframe";
export const YouTubeVideoEmbed = (props) => {
    const src = `${props.videoUrl}${props.webSiteRootUrl ? `?enablejsapi=1&origin=${props.webSiteRootUrl}` : ""}`;
    const splitVideoUrl = props.videoUrl.split("/");
    const videoId = splitVideoUrl.pop();
    const iframeId = `${YOUTUBE_IFRAME_ID_PREFIX}-${videoId}`;
    const styleObj = { width: props.width, height: props.height, maxWidth: props.maxWidth, maxHeight: props.maxHeight };
    return (React.createElement("iframe", { id: iframeId, className: YOUTUBE_IFRAME_ID_PREFIX, style: styleObj, src: src, title: "YouTube video player", allow: "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share", allowFullScreen: true }));
};
